import { render, staticRenderFns } from "./ModalFormRouting.vue?vue&type=template&id=157c8468&scoped=true&"
import script from "./ModalFormRouting.vue?vue&type=script&lang=ts&"
export * from "./ModalFormRouting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c8468",
  null
  
)

export default component.exports